import { ArrowLeft, SearchNormal1 } from "iconsax-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../../../utils/token";
import instance from "../../../../../axios/instance";

export default function TeleMeetingHistory() {

    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState([])

    async function getHistory() {
        setLoading(true)
    
        instance.get("/telemedicine/doctor/meetings/history", {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            setHistory(response.data)
            setLoading(false)
        })
        .catch(error => {
            console.log(error.response.data);
            setHistory([])
            setLoading(false)
        })
    }

    useEffect(() => {
        getHistory()
    }, [])

    if (loading) {
        return <div />
    }

    return (
        <div className="p-3 space-y-6">
            {/* <div className="font-medium text-[17px]">Account History</div> */}

            <div className="flex items-center gap-2">
                <button onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />    
                </button>
                
                <div className="font-medium text-[17px]">Meeting History</div>
            </div>

            <div className="border border-[#20232b22] shadow-sm">
                <div>
                    <div className="w-full flex items-center px-2">
                        <input className="flex-1 py-2 text-[14px] font-normal outline-none" placeholder="Search meeting" />
                        <SearchNormal1 size={18} color="gray" />
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-3 text-[12px] font-semibold w-full bg-[#20232b] text-white p-3">
                    <div className="col-span-3">Date</div>
                    <div className="col-span-3">Patient name</div>
                    <div className="col-span-3">Start time</div>
                    <div className="col-span-2">End time</div>
                    <div className="col-span-1">Duration</div> 
                </div>

                {
                    history.length < 1 ?
                    <div className="p-3 text-[14px] text-gray-500">No recent meeting record</div> :
                    history.map(item => (
                        <div className="grid grid-cols-12 gap-3 text-[14px] w-full border-b p-3">
                            <div className="col-span-3">{new Date(item.created_at).toLocaleDateString().replaceAll("/", "-")}</div>
                            <div className="col-span-3">{item.patient_name}</div>
                            <div className="col-span-3">{new Date(item.start).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true
                            })}</div>
                            <div className="col-span-2">{new Date(item.end).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true
                            })}</div>
                            <div className="col-span-1">30 mins</div> 
                        </div>
                    ))
                }
    
            </div>
        </div>
    )
}